export default "__VITE_ASSET__CNmmlgCb__"